module.exports = __webpack_public_path__ + "img/livepen-small.c9c7f547.png";